export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_FAIL = 'ACTIVATION_FAIL';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const AUTHENTICATED_SUCCESS = 'AUTHENTICATED_SUCCESS';
export const AUTHENTICATED_FAIL = 'AUTHENTICATED_FAIL';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL';
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS';
export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS';
export const GOOGLE_AUTH_FAIL = 'GOOGLE_AUTH_FAIL';
export const FACEBOOK_AUTH_SUCCESS = 'FACEBOOK_AUTH_SUCCESS';
export const FACEBOOK_AUTH_FAIL = 'FACEBOOK_AUTH_FAIL';
export const LOGOUT = 'LOGOUT';
export const UPDATE_PROFILE_SUCCESS="UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_FAIL="UPDATE_PROFILE_FAIL"
export const SHOW_MESSAGES_SUCCESS="SHOW_MESSAGES_SUCCESS"
export const SHOW_MESSAGES_FAIL="SHOW_MESSAGES_SUCCESS"
export const GET_THREAD_SUCCESS="GET_THREAD_SUCCESS"
export const GET_THREAD_FAIL="GET_THREAD_FAIL"
export const CREATE_THREAD_FAIL="CREATE_THREAD_FAIL"
export const CREATE_THREAD_SUCCESS="CREATE_THREAD_SUCCESS"
export const UPDATE_NOTIFI_SUCCESS="UPDATE_NOTIFI_SUCCESS"
export const COMMENT_NOTIFY="COMMENT_NOTIFY"
export const REQUEST_LOGIN="REQUEST_LOGIN"